import {
	LobbyHybridLoginResult,
	LobbyLoginResult,
	LoginParams,
	LoginResult,
	Validate2FAResult,
} from "../model/User";
import apiCaller from "./axios.service";

const baseUrl: string = "/v1/public/identity";

export const login = async (data: LoginParams): Promise<LoginResult> => {
	return apiCaller(`${baseUrl}/signIn`, data);
};

export const validate2FA = async (
	data: LoginParams
): Promise<Validate2FAResult> => {
	return apiCaller(`${baseUrl}/validate2FA`, data);
};

export const signOut = () => {
	return apiCaller(`${baseUrl}/signOut`);
};

export const loginWithToken = async (data: {
	token: string;
}): Promise<LobbyLoginResult> => {
	return apiCaller(`${baseUrl}/signInWithToken`, data);
};

export const loginWithHybridToken = async (data: {
	token: string;
}): Promise<LobbyHybridLoginResult> => {
	return apiCaller(`${baseUrl}/signInWithHybridToken`, data);
};
